/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-target-blank */
import React from "react";
import { OwlSlider } from "../Common";

const HomePage = () => {
  return (
    <>
      <section className="artwork section" id="aboutus">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h2>Sneakpeek of artwork</h2>
            </div>
            <div
              className="col-lg-4 col-md-6 text-center wow fadeInDown"
              data-wow-delay="0.2s"
              style={{ visibility: "visible", animationDelay: "0.2s" }}
            >
              <div className="art-box">
                <div className="img-art">
                  <img src="assets/images/creator-1.png" alt="" />
                </div>
                <div className="title1">Genesis</div>
                <p>
                  2222 Super Creators were sent to planet Earth by the 7 Divine
                  Energies to create peace on Earth during the dark ages.
                </p>
                <a
                  onClick={() => console.log(`Called`)}
                  className="modal-toggle clickable"
                >
                  Read More
                </a>
              </div>
              <div className="modal">
                <div className="modal-wrapper modal-transition">
                  <div className="art-model">
                    <div className="title1">Genesis</div>
                    <p>
                      2222 Super Creators were sent to planet Earth by the 7
                      Divine Energies to create peace on Earth during the dark
                      ages. 1111 Divine Masculine and 1111 Divine Feminine Super
                      Creators were CHOSEN to fulfil a higher purpose. To
                      complete their mission they are gifted with unique and
                      special powers.
                    </p>
                    <button className="modal-close modal-toggle">Close</button>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6 text-center wow fadeInDown"
              data-wow-delay="0.3s"
              style={{ visibility: "visible", animationDelay: "0.3s" }}
            >
              <div className="art-box">
                <div className="img-art">
                  <img src="assets/images/creator-blur2.png" alt="" />
                </div>
                <div className="title1">Legendary</div>
                <p>
                  Scriptures tell of 7 legendary Super creators. In history, the
                  appearance of these divine energies has always resulted in
                  momentous...
                </p>
                <a
                  onClick={() => console.log(`Called`)}
                  className="modal-toggle clickable"
                >
                  Read More
                </a>
              </div>
              <div className="modal">
                <div className="modal-wrapper modal-transition">
                  <div className="art-model">
                    <div className="title1">Legendary</div>
                    <p>
                      Scriptures tell of 7 legendary Super creators. In
                      history,the appearance of these divine energies has always
                      resulted in momentous positive change. Only seekers on the
                      path of enlightenment have the potential to awaken one of
                      these legendary Super Creators. Rumor has it that these
                      legendary divine energies can only be evoked when all 7
                      energy centers have been acquired and activated. What
                      could the awakening of one of these legendary beings bless
                      you with? We shall see...
                    </p>
                    <button className="modal-close modal-toggle">Close</button>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6 text-center wow fadeInDown"
              data-wow-delay="0.3s"
              style={{ visibility: "visible", animationDelay: "0.3s" }}
            >
              <div className="art-box">
                <div className="img-art">
                  <img src="assets/images/SC-babymint.gif" alt="" />
                </div>
                <div className="title1">Juniors</div>
                <p>
                  When the divine feminine and divine masculine re-kindle, a
                  divine connection Is formed. These two beings can fuse their
                  manif...
                </p>
                <a
                  onClick={() => console.log(`Called`)}
                  className="modal-toggle clickable"
                >
                  Read More
                </a>
              </div>
              <div className="modal">
                <div className="modal-wrapper modal-transition">
                  <div className="art-model">
                    <div className="title1">Super Creators - Gen Z</div>
                    <p>
                      Scriptures speak of 5555 divine creations that are
                      destined to aid the 2222 Super Creators; these are the
                      Super Creators - Gen Z.
                    </p>
                    <p>
                      When the divine feminine and divine masculine re-kindle, a
                      divine connection Is formed. After 90 days of their
                      manifestations energies fusing a 'Super Creators Jr' can
                      be manifested.
                    </p>
                    <p>
                      Only a total of 5500 Super Creators Jr can be manifested
                      into this realm.
                    </p>
                    <p>
                      Legend has it there are 55 'Super Babies' that will also
                      arrive on Earth when 5 Super Creators Jr that possess each
                      of the 5 elements are assembled for 90 days. These 'Super
                      Babies' possess extraordinary powers that will no doubt
                      change the world!
                    </p>
                    <button className="modal-close modal-toggle">Close</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="roadmap section" id="roadmap">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h2 className="mb-4">IAC Super Creators Roadmap</h2>
              <div className="subtitle">
                This is the first Conscious NFT of this calibre. The Super
                Creators mission is to bring peace, harmony, success and
                abundance to you and everyone around you. By equipping and
                holding one of these tokens not only will you be one of the 2222
                select few (out of the 3 Million+ Following we have right now)
                to carry a Super Creator, but you will also have access to all
                the super powers, training, knowledge and magic that these Super
                Creators possess. How? Take a look at the roadmap for a brief
                insight to your potential future.
              </div>
            </div>
          </div>
          <div className="line-mobile">
            <div
              className="road-item item1 wow fadeInLeft"
              data-wow-delay="0.2s"
              style={{ visibility: "visible", animationDelay: "0.2s" }}
            >
              <div className="road-img">
                <img src="assets/images/road1.jpg" alt="" />
              </div>
              <div className="road-rt-content">
                <div className="road-title">
                  Phase 0 – The Divine Super Creators are getting ready to
                  descend on earth with their Superpowers.
                </div>
              </div>
            </div>
            <div
              className="road-item item2 wow fadeInRight"
              data-wow-delay="0.2s"
              style={{ visibility: "visible", animationDelay: "0.2s" }}
            >
              <div className="road-img">
                <img src="assets/images/road2.jpg" alt="" />
              </div>
              <div className="road-rt-content">
                <div className="road-title">
                  Phase 1 – 2222 Divine Super creators land on earth on
                  02/02/2022
                </div>
                <div className="road-right-item">
                  <p>
                    2222 Super Creators were summoned to planet Earth by the 7
                    Divine Energies to to bring forth balance and progress the
                    planet toward a new era. Divine Masculine and Divine
                    Feminine Super Creators were CHOSEN to fulfil a higher
                    purpose, and to complete their mission they are gifted with
                    unique and special powers.
                  </p>
                  <p>
                    49 Super Creators have activated the powers locked within
                    their chakras and are now beyond gender. If you are lucky
                    enough to assemble a full set of 7 Super Creators with
                    activated chakras from Root to Crown then you might be able
                    to open the divine portals to the legendary realms.
                    Universal laws dictate that there can only ever be 7 lucky
                    humans in the entire World that will have the opportunity to
                    open these portals.
                  </p>
                  <p>
                    22 Super Creators are unique Avatars that have incarnated{" "}
                    <b>HUMANS!</b> These 22 are leaders who have built up
                    significant followings along their journeys of spreading
                    love, light and positivity in the world. Those that are
                    lucky enough to hold one of these tokens may receive special
                    benefits.
                  </p>
                  <p>
                    Each of these Super Creators will be sent to different parts
                    of the earth to share their Superpowers in the Meta and
                    Physical world.
                  </p>
                </div>
              </div>
            </div>
            <div
              className="road-item item3 wow fadeInLeft"
              data-wow-delay="0.2s"
              style={{ visibility: "visible", animationDelay: "0.2s" }}
            >
              <div className="road-img">
                <img src="assets/images/road3.jpg" alt="" />
              </div>
              <div className="road-rt-content">
                <div className="road-title">
                  PHASE 2 – 5555 BABY CREATORS WILL BEGIN TO BE BORN OUT OF THE
                  UNION OF DIVINE MALE AND FEMALE ON 06/06/2022
                </div>
                <p>
                  Each Baby Creators is gifted with one of the unique powers of
                  the five elements (Earth, Wind, Fire, Air, Water, Space){" "}
                </p>
                <p>
                  After the first Baby Creators is born (90days), the Divine
                  Parents will continue to fuse the next Baby Creator in 60 days
                  and after that, as long as the Divine Parents stays together,
                  they will fuse a Baby Creator every 30 days. (Maximum 5555)
                </p>
                <p>
                  And When 5 Baby Creators, with each of the divine elements on
                  their hands come together they are charged with the powers of
                  the other elements and after 90 days, a super baby will be
                  formed with great value & powers that no one will resist.
                  (Maximum 55)
                </p>
              </div>
            </div>
            <div
              className="road-item item4 wow fadeInRight"
              data-wow-delay="0.2s"
              style={{ visibility: "visible", animationDelay: "0.2s" }}
            >
              <div className="road-img">
                <img src="assets/images/road4.jpg" alt="" />
              </div>
              <div className="road-rt-content">
                <div className="road-title">
                  Phase 3 – 7 legendary divine protectors will appear on earth
                  at the point of singularity of time and space
                </div>
                <p>
                  In Phase 1, 49 Super Creators with activated chakras scattered
                  around the world.
                </p>
                <p>
                  In Phase 3, the 49 will converge to 7 sets of Seven. What does
                  this mean?
                </p>
                <p>
                  There are seven unique Chakras -{" "}
                  <b>
                    Root, Sacral, Solar Plexus, Heart, Throat, Third Eye and
                    Crown 7*7=49!
                  </b>{" "}
                  This means that there will be 7 Unique Collectors of
                  Superpowers who will gather all the 7 Chakras to form their
                  Unique Set. With the merging of each set, 7 LEGENDARY DIVINE
                  PROTECTORS will Descend on EARTH. These divine beings are the
                  most powerful of all and will open up the Portals to the
                  Physical and Meta World.
                </p>
              </div>
            </div>
            <div
              className="road-item item5 wow fadeInLeft"
              data-wow-delay="0.2s"
              style={{ visibility: "visible", animationDelay: "0.2s" }}
            >
              <div className="road-img">
                <img src="assets/images/road5.jpg" alt="" />
              </div>
              <div className="road-rt-content">
                <div className="road-title">Phase 4 – Into the METAVERSE</div>
                <p>
                  The Super Creators will create a Universe for themselves in
                  the META world, where they will continue with their MISSION of
                  Spreading Love, Peace and Harmony.
                </p>
                <p>All Super Creators will have access to our Meta-Land.</p>
                <p>
                  Those that unlock the LEGENDARY Super Creators will have some
                  Unique Benefits that will only be revealed later.
                </p>
              </div>
            </div>
            <div
              className="road-item item6 wow fadeInRight"
              data-wow-delay="0.2s"
              style={{ visibility: "visible", animationDelay: "0.2s" }}
            >
              <div className="road-img">
                <img src="assets/images/road6.jpg" alt="" />
              </div>
              <div className="road-rt-content">
                <div className="road-title">
                  Phase 5 – The land of the creators
                </div>
                <p>
                  The Super Creators will have special Access to the Land of the
                  Creators.
                </p>
                <p>
                  The Creator's land will be a place where you go beyond your
                  limitations and enjoy the Freedom, the PEACE and BLISS with
                  every Breath you take.
                </p>
                <p>
                  At the end of every <b>year</b>, all the Super Creators will
                  convene at the Super Creators Congress for 3 days to protect
                  the Metaverse.
                </p>
                <p>
                  Those that obtain the LEGENDARY Super Creators will have
                  special benefits in the CREATOR'S LAND.
                </p>
              </div>
            </div>
            <div className="lineDraw">
              <img src="assets/images/timeline.png" alt="" title="" />
            </div>
          </div>
        </div>
      </section>

      <div className="who-are section" id="team">
        <div className="container">
          <div className="team-slider">
            <div className="team_title orange-text">Who are we?</div>
            <h2 className="mb-3">Project & Creative Team</h2>
            <OwlSlider
              className={"what-slider"}
              {...{
                nav: true,
                loop: true,
                dots: false,
                margin: 10,
                stagePadding: 70,
                autoplay: false,
                autoplayTimeout: 3000,
                responsive: {
                  0: {
                    items: 1,
                    stagePadding: 0,
                    margin: 0,
                  },
                  575: {
                    items: 2,
                    nav: true,
                  },
                  768: {
                    items: 2,
                    nav: false,
                  },
                  991: {
                    items: 3,
                  },
                  1280: {
                    items: 4,
                  },
                  1400: {
                    items: 5,
                  },
                  1600: {
                    items: 6,
                  },
                },
              }}
            >
              <div className="team-card">
                <div className="team-img">
                  <img src="assets/images/akarshana.jpg" alt="" />
                  <a
                    href="https://twitter.com/SriAkarshana"
                    target="_blank"
                    className="twiter"
                  >
                    <i className="bi bi-twitter"></i>
                  </a>
                  <a
                    href="https://discord.gg/RM9DEK4KV7"
                    target="_blank"
                    className="twiter discord"
                  >
                    <i className="bi bi-discord"></i>
                  </a>
                </div>
                <div className="title2">Master Sri Akarshana</div>
                <p className="orange-text">Spirtual Master</p>
              </div>
              <div className="team-card">
                <div className="team-img">
                  <img src="assets/images/rebecca.jpg" alt="" />
                  <a
                    href="https://twitter.com"
                    target="_blank"
                    className="twiter"
                  >
                    <i className="bi bi-twitter"></i>
                  </a>
                  <a
                    href="https://discord.gg/RM9DEK4KV7"
                    target="_blank"
                    className="twiter discord"
                  >
                    <i className="bi bi-discord"></i>
                  </a>
                </div>
                <div className="title2">Acharya Varalakshmi</div>
                <p className="orange-text">Master Yogini, Spiritual Leader</p>
              </div>
              <div className="team-card">
                <div className="team-img">
                  <img src="assets/images/angela.jpg" alt="" />
                  <a
                    href="https://twitter.com/angelinap93"
                    target="_blank"
                    className="twiter"
                  >
                    <i className="bi bi-twitter"></i>
                  </a>
                  <a
                    href="https://discord.gg/RM9DEK4KV7"
                    target="_blank"
                    className="twiter discord"
                  >
                    <i className="bi bi-discord"></i>
                  </a>
                </div>
                <div className="title2">Angela P. Quintero</div>
                <p className="orange-text">
                  International Speaker, Law of Attraction Coach, Yogini
                </p>
              </div>
              <div className="team-card">
                <div className="team-img">
                  <img src="assets/images/joshua.jpg" alt="" />
                  <a
                    href="https://twitter.com/JoshuaAndre22"
                    target="_blank"
                    className="twiter"
                  >
                    <i className="bi bi-twitter"></i>
                  </a>
                  <a
                    href="https://discord.gg/RM9DEK4KV7"
                    target="_blank"
                    className="twiter discord"
                  >
                    <i className="bi bi-discord"></i>
                  </a>
                </div>
                <div className="title2">Joshua Andre</div>
                <p className="orange-text">
                  Metaphysicist, International Speaker
                </p>
              </div>
              <div className="team-card">
                <div className="team-img">
                  <img src="assets/images/manh.jpg" alt="" />
                  <a
                    href="https://twitter.com/Manh_NFT"
                    target="_blank"
                    className="twiter"
                  >
                    <i className="bi bi-twitter"></i>
                  </a>
                  <a
                    href="https://discord.gg/RM9DEK4KV7"
                    target="_blank"
                    className="twiter discord"
                  >
                    <i className="bi bi-discord"></i>
                  </a>
                </div>
                <div className="title2">Manh Tu Le</div>
                <p className="orange-text">Marketing Expert, NFT Collector</p>
              </div>
              <div className="team-card">
                <div className="team-img">
                  <img src="assets/images/nascia.jpg" alt="" />
                  <a
                    href="https://twitter.com/naspiinzxx"
                    target="_blank"
                    className="twiter"
                  >
                    <i className="bi bi-twitter"></i>
                  </a>
                  <a
                    href="https://discord.gg/RM9DEK4KV7"
                    target="_blank"
                    className="twiter discord"
                  >
                    <i className="bi bi-discord"></i>
                  </a>
                </div>
                <div className="title2">Nascia Pinyung Lee</div>
                <p className="orange-text">
                  Head of Operations & Zen Practitioner
                </p>
              </div>
              <div className="team-card">
                <div className="team-img">
                  <img src="assets/images/nittia.jpg" alt="" />
                  <a
                    href="https://twitter.com/itsnittia"
                    target="_blank"
                    className="twiter"
                  >
                    <i className="bi bi-twitter"></i>
                  </a>
                  <a
                    href="https://discord.gg/RM9DEK4KV7"
                    target="_blank"
                    className="twiter discord"
                  >
                    <i className="bi bi-discord"></i>
                  </a>
                </div>
                <div className="title2">Nittia Thaprakhon</div>
                <p className="orange-text">
                  Community and Social Media Manager
                </p>
              </div>
              <div className="team-card">
                <div className="team-img">
                  <img src="assets/images/paulina.jpg" alt="" />
                  <a
                    href="https://twitter.com/poli_just"
                    target="_blank"
                    className="twiter"
                  >
                    <i className="bi bi-twitter"></i>
                  </a>
                  <a
                    href="https://discord.gg/RM9DEK4KV7"
                    target="_blank"
                    className="twiter discord"
                  >
                    <i className="bi bi-discord"></i>
                  </a>
                </div>
                <div className="title2">Paulina Rzepka</div>
                <p className="orange-text">Social Media Expert</p>
              </div>
              <div className="team-card">
                <div className="team-img">
                  <img src="assets/images/sabrina.jpg" alt="" />
                  <a
                    href="https://twitter.com/iamrinaraya"
                    target="_blank"
                    className="twiter"
                  >
                    <i className="bi bi-twitter"></i>
                  </a>
                  <a
                    href="https://discord.gg/RM9DEK4KV7"
                    target="_blank"
                    className="twiter discord"
                  >
                    <i className="bi bi-discord"></i>
                  </a>
                </div>
                <div className="title2">Sabrina Tekeste Araya</div>
                <p className="orange-text">
                  Community and Social Media Manager
                </p>
              </div>
              <div className="team-card">
                <div className="team-img">
                  <img src="assets/images/team-5.jpg" alt="" />
                  <a
                    href="https://twitter.com/stevish007"
                    target="_blank"
                    className="twiter"
                  >
                    <i className="bi bi-twitter"></i>
                  </a>
                  <a
                    href="https://discord.gg/RM9DEK4KV7"
                    target="_blank"
                    className="twiter discord"
                  >
                    <i className="bi bi-discord"></i>
                  </a>
                </div>
                <div className="title2">Steve Gwilt</div>
                <p className="orange-text">
                  Multi-Award Winning Creative Director & Branding Wizard
                </p>
              </div>
              <div className="team-card">
                <div className="team-img">
                  <img src="assets/images/tim.jpg" alt="" />
                  <a
                    href="https://twitter.com/TimSC_NFT"
                    target="_blank"
                    className="twiter"
                  >
                    <i className="bi bi-twitter"></i>
                  </a>
                  <a
                    href="https://discord.gg/RM9DEK4KV7"
                    target="_blank"
                    className="twiter discord"
                  >
                    <i className="bi bi-discord"></i>
                  </a>
                </div>
                <div className="title2">Tim Tjung</div>
                <p className="orange-text">
                  Community and Social Media Manager
                </p>
              </div>
              <div className="team-card">
                <div className="team-img">
                  <img src="assets/images/team-3.jpg" alt="" />
                  <a
                    href="https://twitter.com/takchiho1"
                    target="_blank"
                    className="twiter"
                  >
                    <i className="bi bi-twitter"></i>
                  </a>
                  <a
                    href="https://discord.gg/RM9DEK4KV7"
                    target="_blank"
                    className="twiter discord"
                  >
                    <i className="bi bi-discord"></i>
                  </a>
                </div>
                <div className="title2">Tak-chi Ho</div>
                <p className="orange-text">Project Manager & Life Coach</p>
              </div>
              <div className="team-card">
                <div className="team-img">
                  <img src="assets/images/giang.jpg" alt="" />
                  <a
                    href="https://twitter.com/Giang01539633"
                    target="_blank"
                    className="twiter"
                  >
                    <i className="bi bi-twitter"></i>
                  </a>
                  <a
                    href="https://discord.gg/RM9DEK4KV7"
                    target="_blank"
                    className="twiter discord"
                  >
                    <i className="bi bi-discord"></i>
                  </a>
                </div>
                <div className="title2">Đỗ Hoàng Giang</div>
                <p className="orange-text">Digital Marketer</p>
              </div>
              {/* <div className="team-card">
                <div className="team-img">
                  <img src="assets/images/maria.jpg" alt="" />
                  <a
                    href="https://twitter.com/itsmemaaaria"
                    target="_blank"
                    className="twiter"
                  >
                    <i className="bi bi-twitter"></i>
                  </a>
                  <a
                    href="https://discord.gg/RM9DEK4KV7"
                    target="_blank"
                    className="twiter discord"
                  >
                    <i className="bi bi-discord"></i>
                  </a>
                </div>
                <div className="title2">Maria Alejandra Muñoz</div>
                <p className="orange-text">
                  Public Relations, Business Manager, Mindset Coach
                </p>
              </div> */}
              <div className="team-card">
                <div className="team-img">
                  <img src="assets/images/mike.jpg" alt="" />
                  <a
                    href="https://twitter.com"
                    target="_blank"
                    className="twiter"
                  >
                    <i className="bi bi-twitter"></i>
                  </a>
                  <a
                    href="https://discord.gg/RM9DEK4KV7"
                    target="_blank"
                    className="twiter discord"
                  >
                    <i className="bi bi-discord"></i>
                  </a>
                </div>
                <div className="title2">Mike Jones</div>
                <p className="orange-text">Director</p>
              </div>
              <div className="team-card">
                <div className="team-img">
                  <img src="assets/images/samantha.jpg" alt="" />
                  <a
                    href="https://twitter.com/Samanth12812552"
                    target="_blank"
                    className="twiter"
                  >
                    <i className="bi bi-twitter"></i>
                  </a>
                  <a
                    href="https://discord.gg/RM9DEK4KV7"
                    target="_blank"
                    className="twiter discord"
                  >
                    <i className="bi bi-discord"></i>
                  </a>
                </div>
                <div className="title2">Samantha Lairenlakpam</div>
                <p className="orange-text">Sales Expert</p>
              </div>
              {/* <div className="team-card">
                <div className="team-img">
                  <img src="assets/images/svenja.jpg" alt="" />
                  <a
                    href="https://twitter.com"
                    target="_blank"
                    className="twiter"
                  >
                    <i className="bi bi-twitter"></i>
                  </a>
                  <a
                    href="https://discord.gg/RM9DEK4KV7"
                    target="_blank"
                    className="twiter discord"
                  >
                    <i className="bi bi-discord"></i>
                  </a>
                </div>
                <div className="title2">Svenja Bergmann</div>
                <p className="orange-text">Wealth Yogi Director & Yogini</p>
              </div> */}
              <div className="team-card">
                <div className="team-img">
                  <img src="assets/images/chetanbala.jpg" alt="" />
                  <a
                    href="https://twitter.com/chetan_hcxl"
                    target="_blank"
                    className="twiter"
                  >
                    <i className="bi bi-twitter"></i>
                  </a>
                  <a
                    href="https://discord.gg/RM9DEK4KV7"
                    target="_blank"
                    className="twiter discord"
                  >
                    <i className="bi bi-discord"></i>
                  </a>
                </div>
                <div className="title2">Chetanbala Hijam</div>
                <p className="orange-text">Digital Marketer</p>
              </div>
              <div className="team-card">
                <div className="team-img">
                  <img src="assets/images/jane.jpg" alt="" />
                  <a
                    href="https://twitter.com/JaneTsai0911"
                    target="_blank"
                    className="twiter"
                  >
                    <i className="bi bi-twitter"></i>
                  </a>
                  <a
                    href="https://discord.gg/RM9DEK4KV7"
                    target="_blank"
                    className="twiter discord"
                  >
                    <i className="bi bi-discord"></i>
                  </a>
                </div>
                <div className="title2">Jane Tsai</div>
                <p className="orange-text">
                  International Speaker, Marketer, Community Manager,Yogini
                </p>
              </div>
              <div className="team-card">
                <div className="team-img">
                  <img src="assets/images/dhan-lairenlakpam.jpg" alt="" />
                  <a
                    href="https://twitter.com/dhanlaisg8"
                    target="_blank"
                    className="twiter"
                  >
                    <i className="bi bi-twitter"></i>
                  </a>
                  <a
                    href="https://discord.gg/Dhan#7190"
                    target="_blank"
                    className="twiter discord"
                  >
                    <i className="bi bi-discord"></i>
                  </a>
                </div>
                <div className="title2">Dhan Lairenlakpam</div>
                <p className="orange-text">Marketing Manager</p>
              </div>
              <div className="team-card">
                <div className="team-img">
                  <img src="assets/images/kaina.jpg" alt="" />
                  <a
                    href="https://twitter.com/MissKaina"
                    target="_blank"
                    className="twiter"
                  >
                    <i className="bi bi-twitter"></i>
                  </a>
                  <a
                    href="https://discord.gg/MissKaina#3741"
                    target="_blank"
                    className="twiter discord"
                  >
                    <i className="bi bi-discord"></i>
                  </a>
                </div>
                <div className="title2">Miss Kaina</div>
                <p className="orange-text">
                  6 Figure NFT Trader, Music, Fashion Lover
                </p>
              </div>
            </OwlSlider>
          </div>
        </div>
      </div>

      <div className="video-tesimonal">
        <div className="container">
          <h2 className="mb-4">
            In Collaboration with Lightworkers of the World
          </h2>
          <div className="subtitle">
            We've carefully selected a handful of lightworkers from around the
            world to join us on our mission. These leaders have demonstrated
            that they are aligned to the Super Creator's mission. Each of these
            leaders has spent years building themselves, spreading love, light
            and positivity in the physical realm. They will now join our efforts
            to spread love through the virtual.
          </div>
          <p>Check out what they have to say below!</p>
          <OwlSlider
            {...{
              nav: true,
              loop: true,
              dots: false,
              margin: 30,
              stagePadding: 0,
              autoplay: false,
              autoplayTimeout: 3000,
              responsive: {
                0: {
                  items: 1,
                  stagePadding: 0,
                  margin: 0,
                },
                575: {
                  items: 2,
                  nav: true,
                },
                768: {
                  items: 2,
                  nav: false,
                },
                991: {
                  items: 3,
                },
                1280: {
                  items: 4,
                },
                1600: {
                  items: 4,
                },
              },
            }}
          >
            <div className="test-video-inside">
              <iframe
                src="https://player.vimeo.com/video/671749112?h=e5ec7b1bfb&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                width="100%"
                height="350"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
                title="Master Wong"
              ></iframe>
              <div className="d-flex">
                <a
                  href="https://www.youtube.com/c/masterwongsystem"
                  target="_blank"
                  className="social-link youtube"
                >
                  <i className="bi bi-youtube"></i>
                </a>
                <div className="info-rt">
                  <div className="title2">Master Wong (2.8M)</div>
                  <p className="orange-text">Author and Martial Art Mindset</p>
                </div>
              </div>
            </div>
            <div className="test-video-inside">
              <iframe
                src="https://player.vimeo.com/video/671749096?h=1bf31a42d5&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                width="100%"
                height="350"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
                title="Aarti"
              ></iframe>
              <div className="d-flex">
                <a
                  href="https://www.facebook.com/aartichabriaofficial"
                  target="_blank"
                  className="social-link facebook"
                >
                  <i className="bi bi-facebook"></i>
                </a>
                <div className="info-rt">
                  <div className="title2">Aarti Chabria (3.4M)</div>
                  <p className="orange-text">
                    Actor, Director, Creative Mindset Coach, and founder of
                    Victorious Mind Power
                  </p>
                </div>
              </div>
            </div>
            <div className="test-video-inside">
              <iframe
                src="https://player.vimeo.com/video/665257028?h=0786bc6ac5&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                width="100%"
                height="350"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
                title="Aditi"
              ></iframe>
              <div className="d-flex">
                <a
                  href="https://www.facebook.com/makeupbyaditibhat"
                  target="_blank"
                  className="social-link facebook"
                >
                  <i className="bi bi-facebook"></i>
                </a>
                <div className="info-rt">
                  <div className="title2">Aditi Dubey (1M+)</div>
                  <p className="orange-text">
                    Make Up Artist, Social Media Influencer
                  </p>
                </div>
              </div>
            </div>
            <div className="test-video-inside">
              <iframe
                src="https://player.vimeo.com/video/670746616?h=02e3735584&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                width="100%"
                height="350"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
                title="Lucie"
              ></iframe>
              <div className="d-flex">
                <a
                  href="https://www.youtube.com/c/LifeByLucie"
                  target="_blank"
                  className="social-link youtube"
                >
                  <i className="bi bi-youtube"></i>
                </a>
                <div className="info-rt">
                  <div className="title2">Lucie England (100K+)</div>
                  <p className="orange-text">
                    Transformation Coach, Entrepreneur, LOA Mentor and Youtuber
                  </p>
                </div>
              </div>
            </div>
            <div className="test-video-inside">
              <iframe
                src="https://player.vimeo.com/video/665257111?h=cf264f2427&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                width="100%"
                height="350"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              ></iframe>
              <div className="d-flex">
                <a
                  href="https://www.youtube.com/c/dashama"
                  target="_blank"
                  className="social-link youtube"
                >
                  <i className="bi bi-youtube"></i>
                </a>
                <div className="info-rt">
                  <div className="title2">Dashama Devi (3M)</div>
                  <p className="orange-text">Founder of Flow State Institute</p>
                </div>
              </div>
            </div>
            <div className="test-video-inside">
              <iframe
                src="https://player.vimeo.com/video/665257177?h=df4a32472a&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                width="100%"
                height="350"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              ></iframe>
              <div className="d-flex">
                <a
                  href="https://www.youtube.com/c/KailynBowman"
                  target="_blank"
                  className="social-link youtube"
                >
                  <i className="bi bi-youtube"></i>
                </a>
                <div className="info-rt">
                  <div className="title2">Kailyn Bowman (100K +)</div>
                  <p className="orange-text">Spiritual Coach and Youtuber</p>
                </div>
              </div>
            </div>
            <div className="test-video-inside">
              <iframe
                src="https://player.vimeo.com/video/685600675?h=91d45420dd&badge=0&autopause=0&player_id=0&app_id=58479"
                width="100%"
                height="350"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              ></iframe>
              <div className="d-flex">
                <a
                  href="https://www.youtube.com/c/TinaReadsYou"
                  target="_blank"
                  className="social-link youtube"
                >
                  <i className="bi bi-youtube"></i>
                </a>
                <div className="info-rt">
                  <div className="title2">Tina Wong (100K +)</div>
                  <p className="orange-text">
                    Multi-Dimension Energy , Intuitive Guide of Tina Reads You
                  </p>
                </div>
              </div>
            </div>
            <div className="test-video-inside">
              <iframe
                src="https://player.vimeo.com/video/685600597?h=ceeb076bfb&badge=0&autopause=0&player_id=0&app_id=58479"
                width="100%"
                height="350"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
                title="Harry Singha"
              ></iframe>
              <div className="d-flex">
                <a
                  href="https://www.linkedin.com/in/harrysingha/?originalSubdomain=uk"
                  target="_blank"
                  className="social-link linkedin"
                >
                  <i className="bi bi-linkedin"></i>
                </a>
                <div className="info-rt">
                  <div className="title2">Harry Singha</div>
                  <p className="orange-text">
                    Speaker, Author, Mentor and Philanthropist
                  </p>
                </div>
              </div>
            </div>
            <div className="test-video-inside">
              <iframe
                src="https://player.vimeo.com/video/671749083?h=9afc57edc6&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                width="100%"
                height="350"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
                title="Christine"
              ></iframe>
              <div className="d-flex">
                <a
                  href="https://www.youtube.com/results?search_query=christine+cheng"
                  target="_blank"
                  className="social-link youtube"
                >
                  <i className="bi bi-youtube"></i>
                </a>
                <div className="info-rt">
                  <div className="title2">Christine Cheng (20K+)</div>
                  <p className="orange-text">
                    Certified Law of Attraction Coach, Reiki Master and Youtuber
                  </p>
                </div>
              </div>
            </div>
            <div className="test-video-inside">
              <iframe
                src="https://player.vimeo.com/video/671747734?h=8acfac9e66&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                width="100%"
                height="350"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
                title="Grandmaster"
              ></iframe>
              <div className="d-flex">
                <a
                  href="https://www.facebook.com/profile.php?id=100044519465890"
                  target="_blank"
                  className="social-link facebook"
                >
                  <i className="bi bi-facebook"></i>
                </a>
                <div className="info-rt">
                  <div className="title2">Grandmaster Akshar (1M+)</div>
                  <p className="orange-text">
                    Internationally acclaimed Spiritual Yogic Master and
                    Visionary
                  </p>
                </div>
              </div>
            </div>
            <div className="test-video-inside">
              <iframe
                src="https://player.vimeo.com/video/671747902?h=cace4874fc&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                width="100%"
                height="350"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
                title="Julianne Ponan"
              ></iframe>
              <div className="d-flex">
                <a
                  href="https://www.linkedin.com/in/julianne-ponan-7464a226/?originalSubdomain=uk"
                  target="_blank"
                  className="social-link linkedin"
                >
                  <i className="bi bi-linkedin"></i>
                </a>
                <div className="info-rt">
                  <div className="title2">Julianne Ponan</div>
                  <p className="orange-text">
                    Forbes 30 Under 30, Founder, CEO at Creative Nature &
                    Speaker
                  </p>
                </div>
              </div>
            </div>
          </OwlSlider>
        </div>
      </div>

      <div className="join-sec">
        <div
          className="container wow fadeInDown"
          data-wow-duration="1s"
          style={{ visibility: "visible", animationDelay: "0.1s" }}
        >
          <div id="particles-js-2" className="particles-js"></div>
          <div className="join-us">
            <div className="title2">
              Join the Super Creators Discord Community
            </div>
            <a
              href="https://discord.gg/RM9DEK4KV7"
              target="_blank"
              className="btn"
            >
              Join Discord community
            </a>
          </div>
        </div>
      </div>

      <div className="community-testimonials">
        <div className="container">
          <h2 className="mb-4">Super Creator Community</h2>
          <div className="subtitle">
            See how excited our community members are about the project!
          </div>
          <OwlSlider
            {...{
              nav: true,
              loop: true,
              dots: false,
              margin: 30,
              stagePadding: 0,
              autoplay: false,
              autoplayTimeout: 3000,
              responsive: {
                0: {
                  items: 1,
                  stagePadding: 0,
                  margin: 0,
                },
                575: {
                  items: 2,
                  nav: true,
                },
                768: {
                  items: 2,
                  nav: false,
                },
                991: {
                  items: 3,
                },
                1280: {
                  items: 4,
                },
                1600: {
                  items: 4,
                },
              },
            }}
          >
            <div className="test-video-inside">
              <iframe
                src="https://player.vimeo.com/video/665021255?h=b4cb1d9a1e&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                width="100%"
                height="350"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="test-video-inside">
              <iframe
                src="https://player.vimeo.com/video/665020959?h=533949a274&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                width="100%"
                height="350"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="test-video-inside">
              <iframe
                src="https://player.vimeo.com/video/665018907?h=f0c5f1eb26&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                width="100%"
                height="350"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="test-video-inside">
              <iframe
                src="https://player.vimeo.com/video/665018503?h=b1bed13b28&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                width="100%"
                height="350"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="test-video-inside">
              <iframe
                src="https://player.vimeo.com/video/665017809?h=e5be5e856f&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                width="100%"
                height="350"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="test-video-inside">
              <iframe
                src="https://player.vimeo.com/video/665017507?h=652c7ac781&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                width="100%"
                height="350"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="test-video-inside">
              <iframe
                src="https://player.vimeo.com/video/665017225?h=cb53a53efb&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                width="100%"
                height="350"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="test-video-inside">
              <iframe
                src="https://player.vimeo.com/video/665017589?h=b2277730d9&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                width="100%"
                height="350"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="test-video-inside">
              <iframe
                src="https://player.vimeo.com/video/665017163?h=81509fb548&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                width="100%"
                height="350"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="test-video-inside">
              <iframe
                src="https://player.vimeo.com/video/665017083?h=545ab5bc3a&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                width="100%"
                height="350"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="test-video-inside">
              <iframe
                src="https://player.vimeo.com/video/665017036?h=d2e0b00a36&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                width="100%"
                height="350"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="test-video-inside">
              <iframe
                src="https://player.vimeo.com/video/665016965?h=1fa443f49f&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                width="100%"
                height="350"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="test-video-inside">
              <iframe
                src="https://player.vimeo.com/video/665016915?h=81966a278f&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                width="100%"
                height="350"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="test-video-inside">
              <iframe
                src="https://player.vimeo.com/video/665016830?h=f4d538c40a&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                width="100%"
                height="350"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="test-video-inside">
              <iframe
                src="https://player.vimeo.com/video/665021449?h=63839c924a&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                width="100%"
                height="350"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="test-video-inside">
              <iframe
                src="https://player.vimeo.com/video/665016782?h=ec18d63650&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                width="100%"
                height="350"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="test-video-inside">
              <iframe
                src="https://player.vimeo.com/video/665017687?h=24bf5b5d1c&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                width="100%"
                height="350"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </OwlSlider>
        </div>
      </div>
    </>
  );
};

export default HomePage;
